import { type } from '@/utils/type'

//////////////////////////////////////////////////////////////////
// ROOM_SERVICES
/////////////////////////////////////////////////////////////////
export const ROOM_SERVICES_DATAS_REQUEST =  type('ROOM_SERVICES_DATAS_REQUEST')
export const ROOM_SERVICES_DATAS_ENSURE =  type('ROOM_SERVICES_DATAS_ENSURE')

export const ROOM_SERVICES_CRENAUX_REQUEST =  type('ROOM_SERVICES_CRENAUX_REQUEST')

export const ROOM_SERVICES_PLAT_SET_SELECTION =  type('ROOM_SERVICES_PLAT_SET_SELECTION')
export const ROOM_SERVICES_ARBO_SET_SELECTION =  type('ROOM_SERVICES_ARBO_SET_SELECTION')

export const ROOM_SERVICES_ADD_PANIER =  type('ROOM_SERVICES_ADD_PANIER')
export const ROOM_SERVICES_UPD_ITEM_COMMENTAIRE =  type('ROOM_SERVICES_UPD_ITEM_COMMENTAIRE')
export const ROOM_SERVICES_UPD_COMMENTAIRE =  type('ROOM_SERVICES_UPD_COMMENTAIRE')
export const ROOM_SERVICES_UPD_ITEM_QTY =  type('ROOM_SERVICES_UPD_ITEM_QTY')
export const ROOM_SERVICES_UPD_HEURE_LIVRAISON =  type('ROOM_SERVICES_UPD_HEURE_LIVRAISON')
export const ROOM_SERVICES_UPD_NB_COUVERTS =  type('ROOM_SERVICES_UPD_NB_COUVERTS')
export const ROOM_SERVICES_UPD_CART_ITEM =  type('ROOM_SERVICES_UPD_CART_ITEM')
export const ROOM_SERVICES_UPD_CONTACT =  type('ROOM_SERVICES_UPD_CONTACT')

export const ROOM_SERVICES_CLEAR_PANIER = type('ROOM_SERVICES_CLEAR_PANIER')




